import { VStack } from '@ayble-health/dashboard-components';
import { SuspectedFoods } from './food/SuspectedFoods';
import React from 'react';
import { useSuspectedFoods } from '../../api/healthCoach/useSuspectedFoods';
import { useParams } from 'react-router-dom';
import { getUserPhase } from './utils';
import { useDashboardPageState } from '../../hooks/useDashboardPageState';
import { TrackableFoods } from './food/TrackableFoods';

export const PhaseFoods = () => {
  const {
    state: { user },
  } = useDashboardPageState();
  const { patient } = useParams();
  const userPhase = getUserPhase(user?.current_phase);
  // check on the id because when switching user with the drawer open, the url (patient param)
  // changes right away while the user needs to be fetched first, so we do this to avoid inconsistencies
  const isChangingUser = patient !== user?.id;

  const { error, isLoading, foods } = useSuspectedFoods(
    patient ?? '',
    !isChangingUser
  );

  // A non-empty foods list means the user has a backstep log — i.e. backstep
  // ran and the coach can pick triggers. We can't gate on `potential_trigger`
  // because that flag only flips to true after triggers have been saved, so
  // the surface that lets the coach pick them in the first place would never
  // appear for users post-backstep but pre-trigger-save.
  const hasFoods = (foods?.length ?? 0) > 0;

  const foodListNotAvailable = error?.message?.indexOf('has no backstep') >= 0;
  const showSuspectedFoods =
    !isChangingUser && !foodListNotAvailable && (userPhase === 2 || hasFoods);

  return (
    <VStack mr="-24px">
      {showSuspectedFoods && (
        <VStack flex={1} pl={0}>
          <SuspectedFoods
            error={error}
            isLoading={isLoading}
            suspectedFoods={foods ?? []}
          />
        </VStack>
      )}

      <VStack flex={1} mt={8}>
        <TrackableFoods />
      </VStack>
    </VStack>
  );
};
